export const ExportTotalsEnum = {
  Chartwells: 1,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/ExportTotalsEnum.js